import { Tab } from "./tab.interface";

export class TabBuilder {
  private tabs: Tab[] = [];

  public add(title: string, contents: JSX.Element): TabBuilder {
    this.tabs = this.tabs.concat([{ title, contents }]);
    return this;
  }

  public getTabs(): Tab[] {
    return this.tabs;
  }
}
